import React from "react";

export const ButtonOval = ({ Icon, elementName, key, value, elementColor }) => {
  const style = {
    backgroundColor: elementColor,
    color: elementColor ? "white" : "black",
    border: elementColor ? "none" : "solid .6px gray",
    boxShadow: "2px 1px 5px rgba(0, 0, 0, 0.1)",
  };
  return (
    <div>
      <button value={value} style={style} className="element">
        {elementName}
        {Icon && <Icon size={24} />}
      </button>
    </div>
  );
};

export default ButtonOval;
